// extracted by mini-css-extract-plugin
export default {"addHotelPage":"AddHotelPage_addHotelPage__FBfeo","confirmModal":"AddHotelPage_confirmModal__kTMYw"};